import { render, staticRenderFns } from "./UserPreferredObjectStore.vue?vue&type=template&id=39999a0d&scoped=true"
import script from "./UserPreferredObjectStore.vue?vue&type=script&lang=js"
export * from "./UserPreferredObjectStore.vue?vue&type=script&lang=js"
import style0 from "./UserPreferredObjectStore.vue?vue&type=style&index=0&id=39999a0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39999a0d",
  null
  
)

export default component.exports